interface BrandLogoProps {
  size?: 'sm' | 'md' | 'lg'
  iconOnly?: boolean
  className?: string
}

const sizes = {
  sm: { icon: 28, text: 'text-lg' },
  md: { icon: 36, text: 'text-2xl' },
  lg: { icon: 48, text: 'text-3xl' },
}

export function BrandLogo({ size = 'md', iconOnly = false, className = '' }: BrandLogoProps) {
  const dimensions = sizes[size]

  return (
    <span className={`inline-flex shrink-0 items-center gap-2.5 text-gray-900 ${className}`}>
      <img
        src="/roomsi-icon.png"
        alt={iconOnly ? 'Roomsi' : ''}
        width={dimensions.icon}
        height={dimensions.icon}
        className="shrink-0 object-contain"
      />
      {!iconOnly && <span className={`${dimensions.text} font-extrabold leading-none`}>Roomsi</span>}
    </span>
  )
}